import { Component, ElementRef, Inject, Input, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatAutocomplete, MatAutocompleteTrigger } from '@angular/material/autocomplete';
import * as dayjs from 'dayjs';
import { DaterangepickerDirective } from 'ngx-daterangepicker-material';
import { AddressesService } from 'app/home/search-box/service/addresses.service';
import { BsModalService, BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { UserService } from 'app/pages/com.usblick.common/auth/user.service';
import { MaterialModalConfirmComponent } from '../material-modal-confirm/material-modal-confirm.component';
import { FormOfflineService } from './form-offline.service';
import { RestService } from '../rest.service';
import { HttpErrorResponse } from '@angular/common/http';
import { BedType, BoardType, CategoryType, RommType, TimeDay, TransmissionType, TypeTransfer, VehicleTypes, VehicleTypesCar } from './models';
import { NgxSpinnerService } from 'ngx-spinner';
import * as moment from 'moment';
import { NotificationService } from '../notifications/notification.service';
import { Subject, of } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap, takeUntil } from 'rxjs/operators';
import { ClientListModalComponent } from '../modals/client-list-modal/client-list-modal.component';
@Component({
  selector: 'usb-form-offline',
  templateUrl: './form-offline.component.html',
  styleUrls: ['./form-offline.component.scss'],
  providers: [AddressesService]
})
export class FormOfflineComponent implements OnInit, OnDestroy {
  @Input() clientSetting: any;
  @ViewChild(DaterangepickerDirective) picker!: DaterangepickerDirective;
  @ViewChild("destination") myInputField: ElementRef;
  @ViewChild('autocompleteInput') autocompleteInput!: ElementRef;
  tab: string = "hotel";
  formHotel: FormGroup;
  formTransfer: FormGroup;
  formRentACar: FormGroup;
  startDate: any;
  dateRange: any = { start: null, end: null };
  minDate: any;
  maxDate: Date;
  max: number;
  rate:number = 0;

  boardType = BoardType;
  roomType = RommType;
  transmissionType = TransmissionType;
  categoryType = CategoryType;
  bedType = BedType;
  typeTransfer = TypeTransfer;
  vehicleTypes = VehicleTypes;
  timeDay = TimeDay;
  vehicleTypesCar = VehicleTypesCar;

  roomsAndPassengers: string;
  originInputValue: string = '';
  pickup: any;
  dropoff: any;
  selectediataCodeDestiny: any;
  selectediataCodeOrigin: any;
  destinationInputValue: any;
  isHoveredCancelDate: boolean;
  isHovered = false;
  mesaggeErrorVisibleOrigin: boolean = false;
  mesaggeErrorVisibleDestination: boolean = false;
  dpConfig: Partial<BsDatepickerConfig> = new BsDatepickerConfig();
  now = new Date();
  currentTime = this.now.toLocaleTimeString([], {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    });
  oneWay: boolean = true;
  backgroundSelect: any;
  buttonColorActive: any;
  buttonTextActive: any;
  formHotelEdited = false;
  formTransferEdited = false;
  formRentACarEdited = false;
  edit: boolean = false;
  bsConfig: object;
  public editData: any;
  bsModalRef?: BsModalRef;
  /**
   * Cliente seleccionado desde el ClientListModalComponent.
   * Se persiste en el formHotel (sub-FormGroup `client`) y se manda
   * al backend como client_id en el payload top-level.
   */
  selectedClient: any = null;
  /** Tipo de solicitud: 'quotation' (cotización) o 'reservation' (reserva). */
  requestType: 'quotation' | 'reservation' = null;
  /**
   * Estado del desplegable de la sección Competencia.
   * `false` = colapsado (se muestra solo el botón "Generar competencia").
   * `true` = expandido (se ven URLs + imágenes + botón para colapsar).
   * Es state UI, no parte del FormGroup: se resetea al colapsar.
   */
  competitorSectionOpen = false;
  /**
   * Lista de países para el autocomplete de phone_code del sub-form de cliente.
   * Misma fuente que usa itinerary-owner: `/utilities/countries`.
   */
  countriesData: any[] = [];
  /**
   * País actualmente seleccionado para phone_code (objeto completo).
   * Sirve para resolver el phone_code_number y mostrar el label legible.
   */
  phoneCodeSelected: any = null;
  /** Opciones de título para el select del sub-form de cliente. */
  clientTitleOptions = ['Sr.', 'Sra.', 'Dr.', 'Lic.'];
  /**
   * Estado del selector "No encuentra hotel" debajo del input hotelsName.
   */
  showHotelSuggest = false;
  hotelSuggestLoading = false;
  hotelSuggestResults: any[] = [];
  hotelSuggestError: string | null = null;
  /**
   * Mientras el selector extendido está abierto, forzamos el cierre del
   * mat-autocomplete de hotelsName (no queremos los dos dropdowns a la vez).
   */
  closeHotelsNameAutocomplete = false;
  /**
   * Estado del segundo paso: cuando el usuario selecciona una sugerencia,
   * polleamos el `run_id` para traer los datos completos. Mientras tanto
   * mostramos un loader y deshabilitamos el resto del selector.
   */
  hotelSuggestEnriching = false;
  /**
   * Mensaje final cuando el run termina pero el hotel aún no aparece
   * en searchlocations (enriquecimiento async tardó más de la cuenta).
   */
  hotelSuggestPending = false;
private originalPickerPosition = { top: 0, left: 0 };

  /**
   * Opciones del autocomplete de "Nombre de hoteles".
   * Solo hoteles — filtramos las ciudades en el front.
   */
  hotelsNameOptions: any[] = [];

  /**
   * Opciones del autocomplete de "Destino".
   * Solo ciudades/ubicaciones — filtramos hoteles/airports en el front.
   */
  destinationOptions: any[] = [];

  /**
   * Subject para disparar la busqueda con debounce (300ms) y cancelar requests en vuelo.
   */
  private hotelsNameSearch$ = new Subject<string>();
  private destinationSearch$ = new Subject<string>();
  private destroy$ = new Subject<void>();

  /**
   * ViewChild del <mat-autocomplete> del campo hotelsName.
   */
  @ViewChild('autoHotelsName') autoHotelsName?: MatAutocomplete;
  /**
   * ViewChild del <mat-autocomplete> del campo destination.
   */
  @ViewChild('autoDestination') autoDestination?: MatAutocomplete;
  /**
   * ViewChild del MatAutocompleteTrigger del input hotelsName.
   * Sirve para cerrar programáticamente el dropdown cuando se abre
   * el selector extendido de "¿No encuentra el hotel?".
   */
  @ViewChild('hotelsNameTrigger', { read: MatAutocompleteTrigger })
  hotelsNameTrigger?: MatAutocompleteTrigger;
    constructor(
          @Inject(MAT_DIALOG_DATA) public data: any,
          public dialogRef: MatDialogRef<FormOfflineComponent>,
          private formBuilder: FormBuilder,
          private notificationService: NotificationService,
          private userService: UserService,
          public dialog: MatDialog,
          private formService: FormOfflineService,
          private restService: RestService,
          private modalService: BsModalService,
          public spinner: NgxSpinnerService,
    ) { this.dpConfig = {
      dateInputFormat: 'DD/MM/YYYY'
    };}

  ngOnInit(): void {
   this.minDate = moment().startOf('day');

    this.clientSetting = this.data?.clientSetting;
    this.edit = this.data?.edit ? true : false;
    this.editData = this.data?.editData;
    const bookingFlow_sidebar = JSON.parse(this.clientSetting?.clients_setting_app_booking?.bookingFlow_sidebar);
    this.backgroundSelect = JSON.parse(this.clientSetting?.clients_setting_app_booking?.bookingFlow_body).card_background_price;
    this.buttonColorActive = bookingFlow_sidebar?.background_color_header;
    this.buttonTextActive = bookingFlow_sidebar?.color;
    if(this.edit && this.editData) {
      this.tabActive(this.editData.category);
      console.log(this.editData.category)
      switch(this.editData.category) {
        case 'hotels':
          this.initFormHotel();
        break;
        case 'transfers':
          this.initFormTransfer();
          break;
        case 'rentacar':
          this.initFormRentACar();
          break;
      }
    }
    if(!this.edit) {
      this.tab = 'hotel';
      this.initFormHotel();
      this.initFormTransfer();
      this.initFormRentACar();

      // Si el invocador pasó datos del formulario de búsqueda (ej: hotels.component.ts),
      // pre-rellenamos los campos comunes del formHotel.
      if (this.data?.prefill) {
        this.prefillHotelFromSearch(this.data.prefill);
      }

      // Setup del autocomplete de "Nombre de hoteles".
      this.setupHotelsNameAutocomplete();
      // Setup del autocomplete de "Destino".
      this.setupDestinationAutocomplete();
      // Carga países para el autocomplete de phone_code del cliente.
      this.loadCountries();
    }
  }

  /**
   * Pre-rellena los campos del formHotel con los valores del formulario
   * de búsqueda de hoteles cuando se abre el modal desde el flujo de
   * "Solicitud offline".
   *
   * Solo se invoca cuando `!edit` (modo creación, no edición).
   *
   * IMPORTANTE: marca `formHotelEdited = true` para que `onSubmit` incluya
   * el producto hotel en el payload. Si quedara en `false`, el componente
   * asumiría que el usuario no tocó nada y omitiría el envío.
   *
   * @param prefill Objeto con: destination, arrivalDepartureDate, nationality,
   *                adults, childs, age_childs, qty_rooms.
   */
  prefillHotelFromSearch(prefill: any): void {
    if (!prefill) {
      return;
    }

    // arrivalDepartureDate: el datepicker (ngx-daterangepicker-md) se bindea
    // principalmente via formControlName, pero también lee/escribe `this.dateRange`
    // para mostrar el rango. Si no actualizamos ambos, el input puede quedar
    // visualmente vacío aunque el FormControl tenga valor.
    if (prefill.arrivalDepartureDate?.start && prefill.arrivalDepartureDate?.end) {
      this.dateRange = {
        start: prefill.arrivalDepartureDate.start,
        end: prefill.arrivalDepartureDate.end
      };
    }

    this.formHotel.patchValue({
      destination: prefill.destination ?? null,
      arrivalDepartureDate: prefill.arrivalDepartureDate ?? null,
      nationality: prefill.nationality ?? null,
      adults: prefill.adults ?? 2,    // default 2 que ya tiene el form
      childs: prefill.childs ?? 0,
      age_childs: prefill.age_childs ?? null,
      qty_rooms: prefill.qty_rooms ?? null,
    });

    this.formHotelEdited = true;
  }

  isInvalidDate = (m: moment.Moment) => {
  return m.isBefore(this.minDate, 'day');
}

  tabActive(tab: string) {
    switch(tab) {
      case 'hotel':
        this.tab = 'hotel';
        break;
      case 'hotels':
        this.tab = 'hotel';
        break;
      case 'transfer':
        this.tab = 'transfer';
        break;
      case 'transfers':
        this.tab = 'transfer';
        break;
      case 'rent-a-car':
        this.tab = 'rent-a-car';
        break;
      case 'rentacar':
        this.tab = 'rent-a-car';
        break;
    }
  }

  initFormHotel(): void {
    this.formHotel = this.formBuilder.group({
      destination:  new FormControl(null, [Validators.required, Validators.minLength(3),Validators.maxLength(80)]),
      arrivalDepartureDate: new FormControl(null, Validators.required),
      hotelsName: new FormControl(null, [Validators.required, Validators.maxLength(100)]),
      star: new FormArray([]),
      zone: new FormControl(null, Validators.maxLength(100)),
      adults: new FormControl(2, [Validators.required, Validators.min(2), Validators.max(99)]),
      childs: new FormControl(0, [Validators.required, Validators.max(99)]),
      age_childs: new FormControl(null),
      qty_rooms: new FormControl(null, [Validators.min(0), Validators.max(99)]),
      price_night: new FormControl(null, Validators.max(99999999)),
      currency: new FormControl(null, Validators.maxLength(12)),
      category: new FormArray([]),
      type_bed: new FormArray([]),
      meals: new FormArray([]),
      roomConfiguration: new FormControl(null),
      nationality: new FormControl(null, [Validators.minLength(3), Validators.maxLength(50)]),
      comment_contact: new FormControl([Validators.minLength(3), Validators.maxLength(500)]),
      competitorUrl: new FormControl(null),
      competitorImages: new FormArray([]),
      competitorUrls: new FormArray([]),
      client: this.formBuilder.group({
        client_id: new FormControl(null),
        title: new FormControl(null),
        first_name: new FormControl(null, [Validators.required, Validators.minLength(2), Validators.pattern(/^[a-zA-ZÀ-ÿ\u00f1\u00d1\s]+$/)]),
        last_name: new FormControl(null),
        email: new FormControl(null, [Validators.required, Validators.email]),
        phone_code: new FormControl(null, Validators.required),
        phone: new FormControl(null, [Validators.required, Validators.pattern(/^[0-9]{6,}$/)])
      }),
      requestType: new FormControl('quotation', Validators.required),
      fileName: new FormControl(null, [Validators.maxLength(50)])
    });

    const initialHotelValue = this.formHotel.getRawValue();

    this.formHotel.valueChanges.subscribe(currentValue => {
      if (JSON.stringify(currentValue) !== JSON.stringify(initialHotelValue)) {
        this.formHotelEdited = true;
      }
    });

    this.formHotel.get('childs').valueChanges.subscribe((value: any) => {
      if(value > 0) {
        this.formHotel.get('age_childs').setValidators(Validators.required);
      } else if (value === 0 || value === '' || value === null) {
         this.formHotel.get('age_childs').clearValidators();
      }
       this.formHotel.get('age_childs').updateValueAndValidity();
    });

    this.formHotel.reset();
    // Reset vuelve todo a null; re-aplicamos el default de requestType
    // para que cotización quede preseleccionado en el formulario nuevo.
    this.formHotel.patchValue({ requestType: 'quotation' });
    // Marcamos como editado desde el inicio porque ya hay un valor por
    // defecto (requestType) — así aparece el badge "Carga de formulario".
    this.formHotelEdited = true;

    if(this.edit && this.editData) {
     this.patchFormHotel(this.editData);
    }

  }

    patchFormHotel(editData: any): void {
      const product = editData?.product || {};
      console.log(product)

      const startDate = product.arrivalDepartureDate?.start
        ? new Date(product.arrivalDepartureDate.start)
        : null;

      const endDate = product.arrivalDepartureDate?.end
        ? new Date(product.arrivalDepartureDate.end)
        : null;

      this.formHotel.patchValue({
        destination: product.destination ?? 'N/A',
        arrivalDepartureDate: startDate && endDate ? { start: startDate, end: endDate } : null,
        hotelsName: product.hotelsName ?? 'N/A',
        zone: product.zone ?? 'N/A',
        adults: product.adults ?? 0,
        childs: product.childs ?? 0,
        age_childs: product.age_childs ?? 'N/A',
        qty_rooms: product.qty_rooms ?? 0,
        price_night: product.price_night ?? 0,
        currency: product.currency ?? 'N/A',
        nationality: product.nationality ?? 'N/A',
        comment_contact: product.comment_contact ?? 'No hay comentarios',
        competitorUrl: product.competitorUrl ?? null,
        client: {
          client_id: editData?.client_id ?? null,
          title: editData?.client?.title ?? null,
          first_name: editData?.client?.first_name ?? null,
          last_name: editData?.client?.last_name ?? null,
          email: editData?.client?.email ?? null,
          phone_code: editData?.client?.phone_code ?? null,
          phone: editData?.client?.phone ?? null
        },
        requestType: editData?.requestType ?? null,
        fileName: editData?.fileName ?? null
      });

      // Hidratar competitorUrls (FormArray). Si hay datos, abrir la sección.
      const editUrls = editData?.competitorUrls;
      if (Array.isArray(editUrls) && editUrls.length > 0) {
        const urlsArray = this.formHotel.get('competitorUrls') as FormArray;
        editUrls.forEach((url: string) => {
          urlsArray.push(new FormControl(url, [Validators.pattern(/^https?:\/\/.+/)]));
        });
        this.competitorSectionOpen = true;
      }

      this.selectedClient = editData?.client ?? null;

      if (product?.competitorImages && Array.isArray(product.competitorImages)) {
        const imagesArray = this.formHotel.get('competitorImages') as FormArray;
        product.competitorImages.forEach((img: string) => {
          imagesArray.push(new FormControl(img));
        });
      }

    if(product?.meals && product?.meals.length > 0){
      product.meals.forEach((meal: any) => {
        let event = {
          target: {
          checked: true,
          value: meal
        }}
        this.onChangeSelectForm(event,'hotel', 'meals');
      })
    }

        if(product?.star && product?.star.length > 0){
      product.star.forEach((meal: any) => {
        let event = {
          target: {
          checked: true,
          value: meal
        }}
        this.onChangeSelectForm(event,'hotel', 'star');
      })
    }

        if(product?.category && product?.category.length > 0){
      product.category.forEach((meal: any) => {
        let event = {
          target: {
          checked: true,
          value: meal
        }}
        this.onChangeSelectForm(event,'hotel', 'category');
      })
    }

        if(product?.type_bed && product?.type_bed.length > 0){
      product.type_bed.forEach((meal: any) => {
        let event = {
          target: {
          checked: true,
          value: meal
        }}
        this.onChangeSelectForm(event,'hotel', 'type_bed');
      })
    }

    this.formHotel.disable();


  };

  initFormTransfer(): void {
    this.formTransfer = this.formBuilder.group({
      firstArrivalDate: new FormControl(null, Validators.required),
      secondArrivalDate: new FormControl(null),
      firstTime: new FormControl(null, Validators.required),
      secondTime: new FormControl(null),
      firstOrigin: new FormControl(null, [Validators.required, Validators.minLength(3), Validators.maxLength(50)]),
      firstDestination: new FormControl(null, [Validators.required, Validators.minLength(3), Validators.maxLength(50)]),
      oneWay: new FormControl(null),
      adults: new FormControl(null, [Validators.required, Validators.min(1), Validators.max(99)]),
      childs: new FormControl(null, [ Validators.min(0), Validators.max(99)]),
      age_childs: new FormControl(null),
      qty_bags: new FormControl(null,[Validators.min(0), Validators.max(99)]),
      typeTransfer: new FormArray([]),
      typeVehicle: new FormArray([]),
      comment_contact: new FormControl(null, [Validators.minLength(3), Validators.maxLength(500)])

    })

    const initialTransferValue = this.formTransfer.getRawValue();

    this.formTransfer.valueChanges.subscribe(currentValue => {
      if (JSON.stringify(currentValue) !== JSON.stringify(initialTransferValue)) {
        this.formTransferEdited = true;
      }
    });

    this.formTransfer.get('childs').valueChanges.subscribe((value: any) => {
      if(value > 0) {
        this.formTransfer.get('age_childs').setValidators(Validators.required);
      } else if (value === 0 || value === '' || value === null) {
         this.formTransfer.get('age_childs').clearValidators();
      }
       this.formTransfer.get('age_childs').updateValueAndValidity();
    });

    this.formTransfer.reset();
    this.formTransferEdited = false;

    if(this.edit && this.editData) {
        this.patchFormTransfer(this.editData);
    }
  }

  patchFormTransfer(editData: any): void {
      const product = editData?.product || {};
      console.log(product)

      const firstArrivalDate = product.firstArrivalDate
        ? new Date(product.firstArrivalDate)
        : null;

      const secondArrivalDate = product.secondArrivalDate
        ? new Date(product.secondArrivalDate)
        : null;

        this.formTransfer.patchValue({
        firstArrivalDate: firstArrivalDate ?? null,
        secondArrivalDate: secondArrivalDate ?? null,
        firstTime: product.firstTime ?? null,
        secondTime: product.secondTime ?? null,
        firstOrigin: product.firstOrigin ?? null,
        firstDestination: product.firstDestination ?? null,
        oneWay: product.secondArrivalDate ? true : false,
        adults: product.adults ?? null,
        childs: product.childs ?? null,
        qty_bags: product.qty_bags ?? 'N/A',
        comment_contact: product.comment_contact ?? 'No hay comentarios'

      });

         if(product?.typeTransfer && product?.typeTransfer.length > 0){
            product.typeTransfer.forEach((meal: any) => {
              let event = {
                target: {
                checked: true,
                value: meal
              }}
              this.onChangeSelectForm(event,'transfer', 'typeTransfer');
            })
    }

       if(product?.typeVehicle && product?.typeVehicle.length > 0){
      product.typeVehicle.forEach((meal: any) => {
        let event = {
          target: {
          checked: true,
          value: meal
        }}
        this.onChangeSelectForm(event,'transfer', 'typeVehicle');
      })
    }

      console.log(this.formTransfer)
      this.formTransfer.disable();
  }

  initFormRentACar(): void {
    this.formRentACar = this.formBuilder.group({
      origin: new FormControl(null, [Validators.required, Validators.minLength(3), Validators.maxLength(50)]),
      pickupDate: new FormControl(null, Validators.required),
      pickupTimeDay: new FormArray([], Validators.required),
      destinationReturn: new FormControl(null, [Validators.minLength(3), Validators.maxLength(50)]),
      dropoffDate: new FormControl(null, Validators.required),
      dropoffTimeDay: new FormArray([], Validators.required),
      vehicleType: new FormArray([]),
      transmissionType: new FormArray([]),
      adults: new FormControl(null, [Validators.required, Validators.min(1), Validators.max(99)]),
      childs: new FormControl(null,  [ Validators.min(0), Validators.max(99)]),
      age_childs: new FormControl(null),
      comment_contact: new FormControl(null, [Validators.minLength(3), Validators.maxLength(500)])
    })

    this.formRentACar.valueChanges.subscribe(() => {
      this.formRentACarEdited = true;
    });

    this.formRentACar.get('childs').valueChanges.subscribe((value: any) => {
      if(value > 0) {
        this.formRentACar.get('age_childs').setValidators(Validators.required);
      } else if (value === 0 || value === '' || value === null) {
         this.formRentACar.get('age_childs').clearValidators();
      }
       this.formRentACar.get('age_childs').updateValueAndValidity();
    });

    this.formRentACar.reset();
    this.formRentACarEdited = false;

      if(this.edit && this.editData) {
        this.patchFormRentACar(this.editData);
    }
  }

  patchFormRentACar(editData: any): void {
      const product = editData?.product || {};
      console.log(product)

      const pickupDate = product.pickupDate
        ? new Date(product.pickupDate)
        : null;

      const dropoffDate = product.dropoffDate
        ? new Date(product.dropoffDate)
        : null;

      this.formRentACar.patchValue({
        origin: product?.origin,
        pickupDate: pickupDate,
        destinationReturn: product.destinationReturn ?? 'N/A',
        dropoffDate: dropoffDate,
        adults: product?.adults,
        childs: product?.childs,
        age_childs: product?.age_childs ?? 'N/A',
        comment_contact: product?.comment_contact ?? 'No hay comentarios'
    });

      if(product?.pickupTimeDay && product?.pickupTimeDay.length > 0){
            product.pickupTimeDay.forEach((meal: any) => {
              let event = {
                target: {
                checked: true,
                value: meal
              }}
              this.onChangeSelectForm(event,'rent-a-car', 'pickupTimeDay');
            })
      }

        if(product?.dropoffTimeDay && product?.dropoffTimeDay.length > 0){
            product.dropoffTimeDay.forEach((meal: any) => {
              let event = {
                target: {
                checked: true,
                value: meal
              }}
              this.onChangeSelectForm(event,'rent-a-car', 'dropoffTimeDay');
            })
      }

        if(product?.vehicleType && product?.vehicleType.length > 0){
            product.vehicleType.forEach((meal: any) => {
              let event = {
                target: {
                checked: true,
                value: meal
              }}
              this.onChangeSelectForm(event,'rent-a-car', 'vehicleType');
            })
      }

        if(product?.transmissionType && product?.transmissionType.length > 0){
            product.transmissionType.forEach((meal: any) => {
              let event = {
                target: {
                checked: true,
                value: meal
              }}
              this.onChangeSelectForm(event,'rent-a-car', 'transmissionType');
            })
      }

       console.log(this.formRentACar)
      this.formRentACar.disable();

  }

  onSubmit(): void {

    const payload: any = {
      client_id: this.formHotel.get('client.client_id')?.value ?? this.userService.clientIdFusion,
      agency_id: this.userService._agencyID,
      agent_id: this.userService._agentID,
      requestType: this.formHotel.get('requestType')?.value ?? null,
      products: {}
    }

    if (this.formHotelEdited) {
      if(this.formHotel.valid) {
        if (!this.formHotel.get('client.client_id')?.value) {
          this.notificationService.info('Debe seleccionar un cliente');
          return;
        }
        if (!this.formHotel.get('requestType')?.value) {
          this.notificationService.info('Debe seleccionar el tipo de solicitud');
          return;
        }
        payload.products.hotels = this.buildPayloadHotel();
        const dateRange = payload.products.hotels.arrivalDepartureDate;
        dateRange.start = moment(dateRange.start.toISOString().split('T')[0]).format('YYYY-MM-DD');
        dateRange.end = moment(dateRange.end.toISOString().split('T')[0]).format('YYYY-MM-DD');
      } else {
        this.notificationService.info('Faltan datos en el formulario de hotel');
        return;
      }
    }

    if (this.formTransferEdited) {
      if(this.formTransfer.valid) {
          payload.products.transfers = this.buildPayloadTransfer();
          payload.products.transfers.oneWay = true;
          let pickupDate = payload.products.transfers.firstArrivalDate;
          let dropoffDate = payload.products.transfers?.secondArrivalDate ?? null;
          pickupDate = moment(pickupDate.toISOString().split('T')[0]).format('YYYY-MM-DD');
          if(dropoffDate) {
            dropoffDate = moment(dropoffDate.toISOString().split('T')[0]).format('YYYY-MM-DD');
            payload.products.transfers.oneWay = false;
          }
          payload.products.transfers.firstArrivalDate = pickupDate;
          payload.products.transfers.secondArrivalDate = dropoffDate;
          payload.products.oneWay = this.formTransfer.get('secondArrivalDate').value ? true : false
      } else {
        this.notificationService.info('Faltan datos en el formulario de traslado');
        return;
      }
    }

    if (this.formRentACarEdited) {

      if(this.formRentACar.valid) {
          payload.products.rentacar = this.buildPayloadRentACar();
          console.log(payload.products.rentacar)
          let pickupDate = payload.products.rentacar.pickupDate;
          let dropoffDate = payload.products.rentacar?.dropoffDate ?? null;
          pickupDate = moment(pickupDate.toISOString().split('T')[0]).format('YYYY-MM-DD');
          if(dropoffDate) {
            dropoffDate = moment(dropoffDate.toISOString().split('T')[0]).format('YYYY-MM-DD');
          }
          payload.products.rentacar.pickupDate = pickupDate;
          payload.products.rentacar.dropoffDate = dropoffDate;
      } else {
        this.notificationService.info('Faltan datos en el formulario de rent a car');
        return;
      }
    }


    if(this.formHotelEdited || this.formTransferEdited || this.formRentACarEdited) {
      const dialogRef = this.dialog.open(MaterialModalConfirmComponent, {
        data: {message: 'Crear solicitud', type: 'material'},
        width: '450px'
      });

console.log(JSON.stringify(payload))

      dialogRef.afterClosed().subscribe((result) => {
        if(result) {
          this.spinner.show();
          this.formService.createRequestOffline(payload).subscribe({
            next: (res: any) => {
              this.close();
              this.spinner.hide();
              this.notificationService.success('Su solicitud ha sido registrada con éxito. Pronto alguno de nuestros operadores se pondrá en contacto con usted');
            },
            error: (error: HttpErrorResponse) => {
              this.notificationService.error('Ha ocurrido un error, vuelva a intentarlo más tarde', 'error: ', error.error);
              this.spinner.hide();
            }
          })
        } else {
          this.spinner.hide();
        }
      });

    } else {
      this.notificationService.info('Complete algún formulario para enviar su solicitud');
    }

  }

    buildPayloadHotel(): any {
      const raw = this.formHotel.value;
        if (raw.currency && typeof raw.currency === 'string') {
            raw.currency = raw.currency.toUpperCase();
        }
      return this.cleanPayload(raw);
    }

    buildPayloadTransfer(): any {
      const raw = this.formTransfer.value;
        if (raw.currency && typeof raw.currency === 'string') {
            raw.currency = raw.currency.toUpperCase();
        }
      return this.cleanPayload(raw);
    }

    buildPayloadRentACar(): any {
      const raw = this.formRentACar.value;
        if (raw.currency && typeof raw.currency === 'string') {
            raw.currency = raw.currency.toUpperCase();
        }
      return this.cleanPayload(raw);
    }

    private cleanPayload(obj: any): any {
      const cleaned: any = {};
      for (const key in obj) {
        const val = obj[key];
        // Filtrar null/undefined
        if (val === null || val === undefined) {
          continue;
        }
        // Filtrar arrays vacíos (ej: competitorUrls: [])
        if (Array.isArray(val) && val.length === 0) {
          continue;
        }
        // Filtrar strings vacíos
        if (typeof val === 'string' && val.trim() === '') {
          continue;
        }
        cleaned[key] = val;
      }
      return cleaned;
    }

  close(): void {
    this.dialogRef.close();
  }


    startDateClicked($event) {
      console.log($event);
      this.startDate = $event;
      //  this.maxDate = moment($event.startDate._d).add(1, 'month');
    }

    endDateClicked($event: any): void {
      // Convertimos a Day.js las fechas para garantizar consistencia
      const selectedStartDate = dayjs(this.startDate.startDate.$d).startOf('day');
      const selectedEndDate = dayjs($event.endDate.$d).startOf('day'); // Normaliza al inicio del día

      console.log('Fecha de inicio:', selectedStartDate.toISOString());
      console.log('Fecha de fin:', selectedEndDate.toISOString());

      // Validar si la fecha de fin es inválida, igual o anterior a la fecha de inicio
      if (!selectedEndDate.isValid() || selectedEndDate.isSame(selectedStartDate) || selectedEndDate.isBefore(selectedStartDate)) {

        this.notificationService.warning('Debe elegir mínimo un día de diferencia con el día de inicio');


        this.formHotel.get('arrivalDate')?.setValue(null); // Limpia el campo en el formulario

        setTimeout(() => {
          this.picker.clear(); // Limpia cualquier selección previa del datePicker
          this.picker.open(); // Reabre el calendario para seleccionar una nueva fecha
          // Resetea el rango de fechas y el formulario
        }, 100);
      } else {
        this.dateRange = { start: selectedStartDate, end: selectedEndDate };
        console.log('Rango de fechas válido:', { start: selectedStartDate, end: selectedEndDate });
      }
    }

    /**
 * Método para intercambiar las ubicaciones de origen y destino.
 *
 * Este método intercambia los valores de origen y destino en el formulario. Los valores se toman de los campos
 * `firstOrigin` y `firstDestination` y luego se aplican en el formulario usando `patchValue`.
 */
swapLocations() {
  // Intercambiar valores del formulario
  const origin = this.formTransfer.get('firstOrigin')?.value;
  const destination = this.formTransfer.get('firstDestination')?.value;

  this.formTransfer.patchValue({
    firstOrigin: destination,
    firstDestination: origin
  });

  // Intercambiar pickup y dropoff
  const tempPickup = this.pickup;
  this.pickup = this.dropoff;
  this.dropoff = tempPickup;

  // Intercambiar códigos IATA
  const tempIata = this.selectediataCodeOrigin;
  this.selectediataCodeOrigin = this.selectediataCodeDestiny;
  this.selectediataCodeDestiny = tempIata;

  // Intercambiar los valores visuales de los inputs
  const tempInputValue = this.originInputValue;
  this.originInputValue = this.destinationInputValue;
  this.destinationInputValue = tempInputValue;
}

/**
 * Método para manejar el cambio de fecha.
 *
 * Este método se utiliza para establecer la fecha de llegada en el formulario y la hora actual,
 * o para restablecer la fecha si el valor es `null`.
 *
 * @value -> valor de tipo Date que representa la nueva fecha de llegada seleccionada.
 */
onDateChange(value: Date | null) {
  if (value) {
    this.oneWay = false;
    this.formTransfer.get('secondArrivalDate').setValue(value);
    this.formTransfer.get('secondTime').setValue(this.currentTime);
  } else {
    this.formTransfer.get('secondArrivalDate').setValue(null);
  }
}

onChangeSelectForm(event: any, form: string, control: string): void {
console.log(event)
  let controlForm;
  switch(form) {
    case 'hotel':
      controlForm = this.formHotel.get(`${control}`) as FormArray;
      break;
    case 'transfer':
      controlForm = this.formTransfer.get(`${control}`) as FormArray;
      break;
    case 'rent-a-car':
      controlForm = this.formRentACar.get(`${control}`) as FormArray;
      break;
  }

  if (event.target.checked) {
    controlForm.push(new FormControl(event.target.value));
  } else {
    const index = controlForm.controls.findIndex(ctrl => ctrl.value === event.target.value);
    if (index !== -1) {
      controlForm.removeAt(index);
    }
  }
}

  /**
   * Getter del FormArray de imágenes de competencia.
   * Permite iterarlo en el template sin castear en cada `*ngFor`.
   */
  get competitorImagesArray(): FormArray {
    return this.formHotel?.get('competitorImages') as FormArray;
  }

  /**
   * Getter del FormArray de URLs de competencia.
   */
  get competitorUrlsArray(): FormArray {
    return this.formHotel?.get('competitorUrls') as FormArray;
  }

  /**
   * Indica si la sección Competencia puede editarse (agregar URLs, imágenes).
   * Se habilita solo cuando los campos OBLIGATORIOS del formHotel están
   * completos. NO considera el estado de `competitorUrls` ni `competitorImages`
   * porque la sección es opcional y sus URLs pueden tener formato inválido
   * durante la edición (el usuario todavía está tipeando).
   *
   * En modo edit siempre es false (toda la sección es read-only).
   */
  get canEditCompetitor(): boolean {
    if (this.edit) {
      return false;
    }
    if (!this.formHotel) {
      return false;
    }

    // Campos opcionales a ignorar al evaluar la validez.
    const OPTIONAL_KEYS = [
      'competitorUrls',
      'competitorImages',
      'competitorUrl',   // legacy singular, ya no se usa
      'fileName',        // opcional
      'age_childs',
      'zone',
      'nationality',
      'qty_rooms',
      'price_night',
      'currency',
      'comment_contact',
      'category',
      'type_bed',
      'meals',
      'roomConfiguration'
    ];

    // Validar todos los controls, marcando como válidos los opcionales.
    let allValid = true;
    Object.keys(this.formHotel.controls).forEach(key => {
      const ctrl = this.formHotel.get(key);
      if (!ctrl) {
        return;
      }
      if (OPTIONAL_KEYS.includes(key)) {
        // Si tiene items hijos (FormArray/FormGroup), los marcamos válidos solo para este chequeo.
        // No los mutamos: leemos status sin propagar.
        // Para FormArrays: chequeamos manualmente cada item.
        if (ctrl instanceof FormArray) {
          // OK, los dejamos fuera del chequeo
          return;
        }
        if (ctrl instanceof FormGroup) {
          // OK, los dejamos fuera del chequeo
          return;
        }
        // FormControl opcional: lo ignoramos
        return;
      }
      // Requerido: tiene que ser válido
      if (ctrl.invalid) {
        allValid = false;
      }
      // Si es FormGroup (sub-form de cliente), chequear cada control adentro.
      if (ctrl instanceof FormGroup) {
        Object.keys(ctrl.controls).forEach(subKey => {
          const subCtrl = ctrl.get(subKey);
          if (subCtrl && subCtrl.invalid) {
            allValid = false;
          }
        });
      }
    });

    return allValid;
  }

  /**
   * Abre/cierra el selector "No encuentra hotel" debajo del input hotelsName.
   * Al abrir, dispara directamente la búsqueda con el valor actual del input
   * hotelsName y la ciudad del campo destination del form (sin pedirle al
   * usuario que re-tipee nada).
   */
  toggleHotelSuggest(): void {
    if (this.showHotelSuggest) {
      this.closeHotelSuggest();
      return;
    }
    this.showHotelSuggest = true;
    this.closeHotelsNameAutocomplete = true;
    // Cerramos el dropdown de searchLocations explícitamente para que no
    // aparezca junto al dropdown extendido.
    if (this.hotelsNameTrigger) {
      this.hotelsNameTrigger.closePanel();
    }
    this.hotelSuggestResults = [];
    this.hotelSuggestError = null;
    this.hotelSuggestPending = false;

    // Tomamos el nombre del input hotelsName. Si es objeto (selección previa
    // del autocomplete), extraemos el name; si es string, lo usamos tal cual.
    const current = this.formHotel.get('hotelsName')?.value;
    let name = '';
    if (current && typeof current === 'object') {
      name = current.name || current.hotel_name || '';
    } else if (typeof current === 'string') {
      name = current;
    }
    if (!name) {
      this.hotelSuggestError = 'Escribe un nombre de hotel para buscar.';
      return;
    }

    // Tomamos la ciudad de destination (puede ser objeto o string).
    const dest = this.formHotel.get('destination')?.value;
    let city = '';
    if (dest && typeof dest === 'object') {
      city = dest.city_name || '';
    } else if (typeof dest === 'string') {
      city = dest;
    }

    this.searchHotelSuggestWith(name, city);
  }

  /**
   * Helper: dispara la búsqueda con los params dados (sin tocar el state de
   * hotelSuggestName/City que ya no usamos como inputs editables).
   */
  private searchHotelSuggestWith(name: string, city: string): void {
    this.hotelSuggestLoading = true;
    this.hotelSuggestError = null;
    this.hotelSuggestResults = [];

    const params: any = { name, enrich: 3, enrich_limit: 3 };
    if (city && city.trim()) {
      params.city = city.trim();
    }

    this.restService.doGet('app', 'contact/hotels/suggest', { params })
      .subscribe({
        next: (res: any) => {
          this.hotelSuggestLoading = false;
          this.hotelSuggestResults = res?.data?.suggestions || [];
          if (this.hotelSuggestResults.length === 0) {
            this.hotelSuggestError = 'No encontramos sugerencias para ese hotel.';
          }
        },
        error: (err) => {
          this.hotelSuggestLoading = false;
          this.hotelSuggestError = 'No pudimos buscar hoteles. Intenta de nuevo.';
          console.error('[hotelSuggest] error', err);
        }
      });
  }

  /**
   * Llama al endpoint de sugerencia de hoteles. Muestra loader y resultados.
   * Shape esperado: { status, message, data: { suggestions: [...], enrichment: {... } } }.
   * NOTA: la búsqueda ahora se dispara desde `toggleHotelSuggest` directamente.
   * Este método queda como no-op público por compatibilidad con el HTML
   * anterior (no se usa más).
   */
  searchHotelSuggest(): void {
    // Re-disparo usando los valores del form por si se quiere re-buscar.
    this.toggleHotelSuggest();
  }

  /**
   * Selecciona una sugerencia de la lista. Dispara el GET al endpoint `run`
   * con el run_id de esa sugerencia. Cuando devuelve los datos completos,
   * re-dispara la búsqueda de `searchlocations` para que el hotel recién
   * creado aparezca en el autocomplete principal.
   */
  selectHotelSuggestion(hotel: any): void {
    if (!hotel) {
      return;
    }
    const runId = hotel.run_id;
    const hotelName = hotel.name || hotel.hotel_name || '';
    if (!runId) {
      this.hotelSuggestError = 'La sugerencia no tiene run_id';
      return;
    }

    this.hotelSuggestEnriching = true;
    this.hotelSuggestError = null;
    this.hotelSuggestPending = false;

    this.restService.doGet('app', 'contact/hotels/suggest/run', {
      params: { run_id: runId }
    }).subscribe({
      next: (res: any) => {
        this.hotelSuggestEnriching = false;
        // El run devuelve la data enriquecida. Si todavía está pending,
        // avisamos y dejamos que el usuario reintente.
        const enrichmentStatus = res?.data?.enrichment?.status;
        if (enrichmentStatus === 'pending') {
          this.hotelSuggestPending = true;
          return;
        }
        // Datos completos: re-buscamos en searchlocations con el nombre
        // del hotel creado para que aparezca en el autocomplete principal.
        this.reloadHotelsNameAutocomplete(hotelName || hotel.requested_name);
      },
      error: (err) => {
        this.hotelSuggestEnriching = false;
        this.hotelSuggestError = 'No pudimos obtener los datos completos. Intenta de nuevo.';
        console.error('[hotelSuggest/run] error', err);
      }
    });
  }

  /**
   * Re-dispara la búsqueda de searchlocations con el nombre del hotel recién
   * creado. Cuando el autocomplete traiga resultados, automáticamente
   * seleccionamos el primero que matchee el nombre y cerramos el selector.
   */
  private reloadHotelsNameAutocomplete(name: string): void {
    if (!name) {
      this.formHotel.get('hotelsName')?.setValue(name);
      this.formHotelEdited = true;
      this.closeHotelSuggest();
      return;
    }

    // Disparamos la búsqueda manualmente usando el mismo endpoint.
    this.restService.doGet('api', `/utilities/searchlocations/${encodeURIComponent(name)}?category=HOTELS`)
      .subscribe({
        next: (res: any) => {
          const hotels = res?.hotels || [];
          // Buscamos el hotel que matchee por nombre (case-insensitive).
          const match = hotels.find((h: any) =>
            h?.name && name && h.name.toLowerCase().includes(name.toLowerCase())
          );
          if (match) {
            this.formHotel.get('hotelsName')?.setValue(match);
            this.onHotelsNameSelected(match);
          } else {
            // Si no matchea por nombre, igual dejamos el nombre en el input.
            this.formHotel.get('hotelsName')?.setValue(name);
            this.formHotelEdited = true;
          }
          this.closeHotelSuggest();
        },
        error: () => {
          // Si falla la búsqueda, igual dejamos el nombre tipeado.
          this.formHotel.get('hotelsName')?.setValue(name);
          this.formHotelEdited = true;
          this.closeHotelSuggest();
        }
      });
  }

  /**
   * Cierra el selector y limpia estado temporal.
   */
  closeHotelSuggest(): void {
    this.showHotelSuggest = false;
    this.closeHotelsNameAutocomplete = false;
    this.hotelSuggestResults = [];
    this.hotelSuggestError = null;
    this.hotelSuggestPending = false;
  }

  /**
   * Se dispara cuando el usuario hace focus o escribe en el input hotelsName.
   * Si el selector extendido de "¿No encuentra?" está abierto, lo cerramos
   * para que solo quede el dropdown nativo de searchLocations.
   */
  onHotelsNameFocus(): void {
    if (this.showHotelSuggest) {
      this.closeHotelSuggest();
    }
  }

  /**
   * Abre el desplegable de Competencia y agrega la primera URL vacía.
   * Solo se invoca cuando NO estamos en edit (en edit el botón no se muestra).
   */
  openCompetitorSection(): void {
    this.competitorSectionOpen = true;
    this.addCompetitorUrl();
  }

  /**
   * Cierra el desplegable y LIMPIA todas las URLs y todas las imágenes
   * (acorde al requerimiento: al colapsar se pierden los datos).
   */
  closeCompetitorSection(): void {
    this.competitorSectionOpen = false;
    this.competitorUrlsArray?.clear();
    this.competitorImagesArray?.clear();
  }

  /**
   * Agrega un FormControl vacío para una nueva URL al array de URLs.
   */
  addCompetitorUrl(): void {
    // Las URLs son opcionales individualmente. Si el usuario completa una,
    // se valida con pattern http/https. Si no completa nada, no se manda al backend.
    this.competitorUrlsArray?.push(
      new FormControl(null, [Validators.pattern(/^https?:\/\/.+/)])
    );
  }

  /**
   * Quita una URL del array por índice.
   */
  removeCompetitorUrl(index: number): void {
    if (index >= 0 && index < this.competitorUrlsArray.length) {
      this.competitorUrlsArray.removeAt(index);
    }
  }

  /**
   * Abre el modal de selección de clientes (ClientListModalComponent) ya existente
   * en el proyecto. Reutiliza el mismo endpoint y patrón que itinerary-owner.
   */
  openClientListModal(): void {
    const initialState: ModalOptions = {
      initialState: {
        clientEmail: this.formHotel.get('client.email')?.value ?? '',
      },
      class: 'modal-lg modal-edit-search',
    };
    this.bsModalRef = this.modalService.show(ClientListModalComponent, initialState);

    this.bsModalRef.content.clientSelected.subscribe((client: any) => {
      this.onClientSelected(client);
    });
  }

  /**
   * Maneja el cliente emitido por el modal. Pinta el sub-FormGroup y marca
   * el form como editado. Si el cliente trae phone_code (lo resuelve el modal
   * via countriesData), lo usamos; si no, lo dejamos para que el usuario lo complete.
   */
  onClientSelected(client: any): void {
    if (!client) {
      return;
    }
    this.selectedClient = client;
    this.formHotel.get('client')?.patchValue({
      client_id: client.id,
      title: client.title ?? null,
      first_name: client.first_name ?? null,
      last_name: client.last_name ?? null,
      email: client.email ?? null,
      phone_code: client.phone_code_number ?? client.phone_code ?? null,
      phone: client.phone ?? null
    });

    // Si el modal ya resolvió el phone_code_resolved, lo guardamos en el state
    // para que el input lo muestre legible (ej: "Argentina (+54)").
    if (client.phone_code_resolved) {
      this.phoneCodeSelected = client.phone_code_resolved;
    }

    this.formHotelEdited = true;
  }

  /**
   * Carga la lista de países para el autocomplete de phone_code del sub-form
   * de cliente. Mismo endpoint que usa itinerary-owner: `/utilities/countries`.
   */
  loadCountries(): void {
    this.restService.doGet('api', '/utilities/countries')
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          this.countriesData = res?.Countrys || res?.countries || [];
        },
        error: () => {
          this.countriesData = [];
        }
      });
  }

  /**
   * Cuando el usuario selecciona un país del autocomplete, guardamos el objeto
   * completo en `phoneCodeSelected` (para mostrar el label legible) y solo el
   * `phone_code` numérico en el FormControl.
   */
  onCountrySelected(country: any): void {
    if (!country) {
      return;
    }
    this.phoneCodeSelected = `${country.country_name} (+${country.phone_code})`;
    this.formHotel.get('client.phone_code')?.setValue(country.phone_code);
  }

  /**
   * displayWith para el mat-autocomplete de phone_code.
   * Devuelve "Country (+phone_code)" si está seleccionado, o el string crudo
   * si el usuario está tipeando.
   */
  displayCountryFn = (value: any): string => {
    if (!value) {
      return '';
    }
    if (typeof value === 'string') {
      return value;
    }
    return `${value.country_name} (+${value.phone_code})`;
  };

  /**
   * Quita el cliente seleccionado. Limpia el sub-FormGroup y el state.
   */
  clearSelectedClient(): void {
    this.selectedClient = null;
    this.phoneCodeSelected = null;
    this.formHotel.get('client')?.reset({
      client_id: null,
      title: null,
      first_name: null,
      last_name: null,
      email: null,
      phone_code: null,
      phone: null
    });
  }

  /**
   * Handler del input de imágenes de competencia.
   * Valida tamaño (5 MB máx) y tipo (image/*). Por cada File válido lee el base64
   * (sin el prefijo `data:image/...;base64,`) y lo empuja al FormArray.
   * Si una imagen falla el filtro, notifica y la omite sin abortar el resto.
   */
  onCompetitorImagesSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (!input.files || input.files.length === 0) {
      return;
    }

    const files = Array.from(input.files);
    const imagesArray = this.formHotel.get('competitorImages') as FormArray;
    const MAX_BYTES = 5 * 1024 * 1024;

    files.forEach((file) => {
      if (!file.type.startsWith('image/')) {
        this.notificationService.warning(`${file.name} no es una imagen válida`);
        return;
      }
      if (file.size > MAX_BYTES) {
        this.notificationService.warning(`${file.name} supera el límite de 5 MB`);
        return;
      }

      const reader = new FileReader();
      reader.onload = () => {
        const result = reader.result as string;
        // result viene como "data:image/png;base64,iVBORw0..." — nos quedamos con el payload puro.
        const commaIndex = result.indexOf(',');
        const base64 = commaIndex >= 0 ? result.substring(commaIndex + 1) : result;
        imagesArray.push(new FormControl(base64));
      };
      reader.readAsDataURL(file);
    });

    // Limpia el input para permitir re-subir el mismo archivo si fue removido.
    input.value = '';
  }

  /**
   * Quita una imagen del FormArray por índice.
   */
  removeCompetitorImage(index: number): void {
    const imagesArray = this.formHotel.get('competitorImages') as FormArray;
    if (index >= 0 && index < imagesArray.length) {
      imagesArray.removeAt(index);
    }
  }

resetForm(type): void {
  switch(type) {
    case 'hotel':
      // this.initFormHotel();
      this.formHotel.reset();
      (this.formHotel.get('competitorImages') as FormArray).clear();
      (this.formHotel.get('competitorUrls') as FormArray).clear();
      // Reset vuelve todo a null; re-aplicamos el default de requestType
      // para que cotización quede preseleccionado otra vez.
      this.formHotel.patchValue({ requestType: 'quotation' });
      this.competitorSectionOpen = false;
      this.clearSelectedClient();
      // Marcamos como editado porque ya hay un valor por defecto cargado.
      this.formHotelEdited = true;
    break;
    case 'transfer':
      // this.initFormHotel();
      this.formTransfer.reset();
      this.formTransferEdited = false;
    break;
    case 'rent-a-car':
      // this.initFormHotel();
      this.formRentACar.reset();
      this.formRentACarEdited = false;
    break;
  }
}

fixCalendarPosition(): void {
  if(this.picker) {
    this.picker.open();

    setTimeout(() => {
      const pickerElement = document.querySelector('ngx-daterangepicker-material') as HTMLElement;
      const inputElement = document.querySelector('.input-ngxDateRangePicker') as HTMLElement;

      if (pickerElement && inputElement) {
        const inputRect = inputElement.getBoundingClientRect();
        const pickerRect = pickerElement.getBoundingClientRect();
        const viewportWidth = window.innerWidth;
        const viewportHeight = window.innerHeight;

        // Posición FIJA a la derecha del input
        let rightPosition = inputRect.left + window.scrollX + 5; // 5px de margen
        let topPosition = inputRect.top + window.scrollY;

        // Verificar si cabe a la derecha, si no, ajustar al borde derecho
        if (rightPosition + pickerRect.width > viewportWidth) {
          rightPosition = viewportWidth - pickerRect.width - 10; // 10px de margen del borde
        }

        // Verificar posición vertical - asegurar que no se salga
        if (topPosition + pickerRect.height > viewportHeight) {
          topPosition = viewportHeight - pickerRect.height - 10; // Alinear con parte inferior
        }

        // Aplicar estilos para posición fija a la derecha
        pickerElement.style.position = 'fixed';
        pickerElement.style.top = `${topPosition}px`;
        pickerElement.style.right = `${rightPosition}px`;
        pickerElement.style.transform = 'none';
        pickerElement.style.zIndex = '99999';
        pickerElement.style.margin = '0';
      }
    }, 0);
  }
}
adjustPickerPosition(pickerElement: HTMLElement, inputRect: DOMRect) {
  const pickerRect = pickerElement.getBoundingClientRect();
  const viewportHeight = window.innerHeight;
  const viewportWidth = window.innerWidth;

  // Ajuste vertical (si no cabe abajo, mostramos arriba)
  if (pickerRect.bottom > viewportHeight) {
    pickerElement.style.top = `${inputRect.top + window.scrollY - pickerRect.height}px`;
  }

  // Ajuste horizontal (si no cabe a la derecha, alineamos a la izquierda)
  if (pickerRect.right > viewportWidth) {
    pickerElement.style.left = `${viewportWidth - pickerRect.width - 10}px`;
  }
}

limitNumber(event: KeyboardEvent, max: number) {
    const input = event.target as HTMLInputElement;
    const value = input.value + event.key;

  if (Number(value) > max) {
    event.preventDefault();
  }
}

     /**
   * Bloquea la entrada de caracteres no deseados (`e`, `E`, `+`, `-`) en campos numéricos.
   * @param event El evento de teclado.
   */
blockInvalidKeys(event: KeyboardEvent, input?: string) {
    const key = event.key;

    switch (input) {
        case 'name':
            // Permitir teclas especiales: Backspace, Delete, Tab, Escape, Enter, y las flechas
            if (
              [
                'Backspace',
                'Delete',
                'Tab',
                'Escape',
                'Enter',
                'ArrowLeft',
                'ArrowRight',
              ].includes(key)
            ) {
              return; // Permitir estas teclas
            }

            // Bloquear caracteres que no coincidan con letras, acentos, ñ o espacios
            if (!/^[a-zA-ZÀ-ÿ\u00f1\u00d1\s]$/.test(key)) {
              event.preventDefault();
            }
            break;

        case 'number':
            if (['e', 'E', '+', '-', ',', '.'].includes(key)) {
                event.preventDefault();
              }
            break;
        case 'price':
            if (['e', 'E', '+', '-',].includes(key)) {
                event.preventDefault();
              }
            break;

        case 'age_childs':
             // Permitir teclas especiales: Backspace, Delete, Tab, Escape, Enter, y las flechas
                if (
                    [
                        'Backspace',
                        'Delete',
                        'Tab',
                        'Escape',
                        'Enter',
                        'ArrowLeft',
                        'ArrowRight',
                        'Home',
                        'End'
                    ].includes(key)
                ) {
                    return; // Permitir estas teclas
                }

                // Permitir números (0-9), comas y espacios
                if (!/^[0-9,\s]$/.test(key)) {
                    event.preventDefault();
                }
            break;
            case 'currency':
            // Permitir teclas especiales: Backspace, Delete, Tab, Escape, Enter, y las flechas
            if (
                [
                    'Backspace',
                    'Delete',
                    'Tab',
                    'Escape',
                    'Enter',
                    'ArrowLeft',
                    'ArrowRight',
                    'Home',
                    'End',
                    ' '
                ].includes(key)
            ) {
                return; // Permitir estas teclas
            }

            // Permitir letras (A-Z, a-z) y comas
            if (!/^[a-zA-Z,]$/.test(key)) {
                event.preventDefault();
            }
            break;
                }
      }

      /**
 * Limita los decimales a máximo 2 después del punto/coma
 */
limitDecimals(event: Event) {
    const input = event.target as HTMLInputElement;
    let value = input.value;

    // Reemplazar coma por punto para consistencia
    value = value.replace(',', '.');

    // Verificar si tiene decimales
    if (value.includes('.')) {
        const parts = value.split('.');

        // Si hay más de 2 decimales, truncar a 2
        if (parts[1] && parts[1].length > 2) {
            parts[1] = parts[1].substring(0, 2);
            value = parts[0] + '.' + parts[1];
        }

        // Actualizar el valor
        input.value = value;
    }
}

/**
 * Formatea automáticamente el input de currency después de escribir 3 letras
 * @param event El evento de input
 */
formatCurrencyInput(event: Event) {
    const input = event.target as HTMLInputElement;
    const cursorPosition = input.selectionStart;
    let value = input.value.toUpperCase().replace(/[^A-Z,]/g, '');

    // Dividir por comas y procesar cada parte
    const parts = value.split(',');

    // Filtrar partes vacías y limpiar cada parte (máximo 3 caracteres)
    const cleanedParts = parts.map(part => part.replace(/[^A-Z]/g, '').substring(0, 3));

    // Reconstruir el valor uniendo con comas + ESPACIO
    value = cleanedParts.join(', '); // <- Cambio aquí

    // Solo agregar coma + ESPACIO automáticamente si:
    // - La última parte tiene exactamente 3 caracteres
    // - No estamos borrando (el nuevo valor es más largo que el anterior)
    // - No está ya seguido de una coma
    const lastPart = cleanedParts[cleanedParts.length - 1];
    if (lastPart.length === 3 &&
        value.length > input.value.length &&
        !value.endsWith(',')) {
        value += ', '; // <- Cambio aquí también
    }

    // Actualizar el valor
    input.value = value;

    // Ajustar la posición del cursor
    if (cursorPosition !== null) {
        const newPosition = Math.min(cursorPosition, value.length);
        input.setSelectionRange(newPosition, newPosition);
    }
  }

  /**
   * Configura el autocomplete del campo "Nombre de hoteles".
   * Llama a /utilities/searchlocations/{keyword}?category=HOTELS y filtra SOLO hoteles
   * en el dropdown (ignoramos cities, airports, airlines).
   *
   * Debounce 300ms para no saturar el endpoint mientras el usuario tipea.
   * distinctUntilChanged evita re-disparar si el valor no cambió (ej: cuando
   * el autocomplete reescribe el input con displayWith).
   * switchMap cancela el request en vuelo si el usuario sigue tipeando.
   */
  setupHotelsNameAutocomplete(): void {
    const ctrl = this.formHotel.get('hotelsName');
    if (!ctrl) {
      console.error('[hotelsName] hotelsName control NOT FOUND in formHotel');
      return;
    }
    this.hotelsNameSearch$
      .pipe(
        debounceTime(300),
        distinctUntilChanged(),
        switchMap((keyword: string) => {
          if (!keyword || keyword.length < 3) {
            return of(null);
          }
          return this.restService.doGet('api', `/utilities/searchlocations/${keyword}?category=HOTELS`);
        }),
        takeUntil(this.destroy$)
      )
      .subscribe({
        next: (res: any) => {
          if (!res) {
            this.hotelsNameOptions = [];
            return;
          }
          // Solo hoteles en el dropdown.
          this.hotelsNameOptions = [
            {
              hotels: res?.hotels || [],
              type: 'hotel',
            },
          ];
        },
        error: () => {
          this.hotelsNameOptions = [];
        },
      });

    // Conectar el valueChanges del control al Subject.
    this.formHotel.get('hotelsName')?.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe((value: any) => {
        if (value && typeof value === 'object') {
          return;
        }
        this.hotelsNameSearch$.next(value || '');
      });
  }

  /**
   * Configura el autocomplete del campo "Destino".
   * Llama al mismo endpoint SIN category (o con category=HOTELS, da igual) y filtra
   * SOLO ciudades en el front, descartando hoteles, airports y airlines.
   *
   * Mismo patrón de debounce/distinct/switchMap que hotelsName.
   */
  setupDestinationAutocomplete(): void {
    const ctrl = this.formHotel.get('destination');
    if (!ctrl) {
      console.error('[destination] destination control NOT FOUND in formHotel');
      return;
    }
    this.destinationSearch$
      .pipe(
        debounceTime(300),
        distinctUntilChanged(),
        switchMap((keyword: string) => {
          if (!keyword || keyword.length < 3) {
            return of(null);
          }
          // Mismo endpoint que usa hotelsName. Filtramos en el front.
          return this.restService.doGet('api', `/utilities/searchlocations/${keyword}?category=HOTELS`);
        }),
        takeUntil(this.destroy$)
      )
      .subscribe({
        next: (res: any) => {
          if (!res) {
            this.destinationOptions = [];
            return;
          }
          // Solo ciudades/ubicaciones en el dropdown.
          this.destinationOptions = [
            {
              cities: res?.cities || [],
              type: 'city',
            },
          ];
        },
        error: () => {
          this.destinationOptions = [];
        },
      });

    this.formHotel.get('destination')?.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe((value: any) => {
        if (value && typeof value === 'object') {
          return;
        }
        this.destinationSearch$.next(value || '');
      });
  }

  /**
   * displayWith para el mat-autocomplete de destination.
   * Devuelve `city_name` (con provincia/país si están) o el string crudo.
   */
  displayDestinationFn = (value: any): string => {
    if (!value) {
      return '';
    }
    if (typeof value === 'string') {
      return value;
    }
    return value.city_name || value.name || '';
  };

  /**
   * Maneja la selección de una ciudad del autocomplete de destination.
   * Guarda el objeto completo en el FormControl y marca formHotelEdited.
   */
  onDestinationSelected(selected: any): void {
    if (!selected) {
      return;
    }
    this.formHotel.get('destination')?.setValue(selected);
    this.formHotelEdited = true;
  }

  /**
   * displayWith para el mat-autocomplete de hotelsName.
   * Devuelve `name` si es hotel, `city_name` si es ciudad, o el string crudo si
   * el usuario está tipeando texto libre.
   */
  displayHotelsNameFn = (value: any): string => {
    if (!value) {
      return '';
    }
    if (typeof value === 'string') {
      return value;
    }
    // Hotel: tiene `name` y `city_name`. Ciudad: tiene `city_name` y `country_name`.
    return value.name || value.city_name || '';
  };

  /**
   * Maneja la selección de un item del autocomplete. Guarda el objeto completo
   * en el FormControl para no perder info (tipo, id, iata) y marca formHotelEdited.
   */
  onHotelsNameSelected(selected: any): void {
    if (!selected) {
      return;
    }
    this.formHotel.get('hotelsName')?.setValue(selected);
    this.formHotelEdited = true;
  }

  /**
   * Capitaliza un string tipo titulo (primera letra de cada palabra en mayuscula).
   * Replica lo que hace el search-box de hoteles para mantener consistencia visual.
   */
  capitalize(val: any): string {
    if (val === undefined || val === null) {
      return '';
    }
    return String(val)
      .toLowerCase()
      .trim()
      .split(' ')
      .map((v) => v.charAt(0).toUpperCase() + v.substring(1))
      .join(' ');
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
